import { render, staticRenderFns } from "./CiSum.vue?vue&type=template&id=33e7f227&scoped=true"
import script from "./CiSum.vue?vue&type=script&lang=js"
export * from "./CiSum.vue?vue&type=script&lang=js"
import style0 from "./CiSum.vue?vue&type=style&index=0&id=33e7f227&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e7f227",
  null
  
)

export default component.exports